<template>
    <div id="terms">
        <picture>
            <source :srcset="$url + 'img/bg_acesso.webp'" type="image/webp">
            <source :srcset="$url + 'img/bg_acesso.png'" type="image/png"> 
            <img id="bg" :src="$url + 'img/bg_acesso.webp'">
        </picture>
        <div id="bg-1"></div>
        <picture>
            <source :srcset="$url + 'img/instrucao/raio_instrucao.webp'" type="image/webp">
            <source :srcset="$url + 'img/instrucao/raio_instrucao.png'" type="image/png"> 
            <img id="raio" :src="$url + 'img/instrucao/raio_instrucao.webp'">
        </picture>
        <transition name="fade">
            <div v-if="show" id="box">
                <h3>Termos de privacidade</h3>
                <span><a href="#" v-on:click="exit"><img :src="$url + 'img/fechar.png'"></a></span>
                <div id="menu">
                    <ul>
                        <li><a href="#o-que-sao-cookies">O que são cookies?</a></li>
                        <li><a href="#como-usamos-os-cookies">Como usamos os cookies?</a></li>
                        <li><a href="#desativar-cookies">Desativar cookies</a></li>
                        <li><a href="#cookies-que-definimos">Cookies que definimos</a></li>
                        <li><a href="#mais-informacoes">Mais informações</a></li>
                    </ul>
                </div>
                <div id="textos">
                    <div id="o-que-sao-cookies">
                        <h1>O que são cookies?</h1>
                        Como é prática comum em quase todos os sites profissionais, este site usa cookies, que são pequenos arquivos baixados no seu computador, para melhorar sua experiência. Esta página descreve quais informações eles coletam, como as usamos e por que às vezes precisamos armazenar esses cookies. Também compartilharemos como você pode impedir que esses cookies sejam armazenados, no entanto, isso pode fazer o downgrade ou 'quebrar' certos elementos da funcionalidade do site.
                    </div>
                    <div id="como-usamos-os-cookies">
                        <h1>Como usamos os cookies?</h1>
                        Utilizamos cookies para auxiliar no seu processo de identificação durante o login e navegação. Infelizmente, na maioria dos casos, não existem opções padrão do setor para desativar os cookies sem desativar completamente a funcionalidade e os recursos que eles adicionam a este site. É recomendável que você deixe todos os cookies se não tiver certeza se precisa ou não deles, caso sejam usados para fornecer um serviço que você usa.
                    </div>
                    <div id="desativar-cookies">
                        <h1>Desativar cookies</h1>
                        Você pode impedir a configuração de cookies ajustando as configurações do seu navegador (consulte a Ajuda do navegador para saber como fazer isso). Esteja ciente de que a desativação de cookies afetará a funcionalidade deste e de muitos outros sites que você visita. A desativação de cookies geralmente resultará na desativação de determinadas funcionalidades e recursos deste site. Portanto, é recomendável que você não desative os cookies.

                    </div>
                    <div id="cookies-que-definimos">
                        <h1>Cookies que definimos</h1>
                        Cookies relacionados à conta
                        Se você criar uma conta conosco, usaremos cookies para o gerenciamento do processo de inscrição e administração geral. Esses cookies geralmente serão excluídos quando você sair do sistema, porém, em alguns casos, eles poderão permanecer posteriormente para lembrar as preferências do seu site ao sair.
                        Cookies relacionados ao login
                        Utilizamos cookies quando você está logado, para que possamos lembrar dessa ação. Isso evita que você precise fazer login sempre que visitar uma nova página. Esses cookies são normalmente removidos ou limpos quando você efetua logout para garantir que você possa acessar apenas a recursos e áreas restritas ao efetuar login.
                        Cookies de preferências do site
                        Para proporcionar uma ótima experiência neste site, fornecemos a funcionalidade para definir suas preferências de como esse site é executado quando você o usa. Para lembrar suas preferências, precisamos definir cookies para que essas informações possam ser chamadas sempre que você interagir com uma página for afetada por suas preferências.
                    </div>
                    <div id="mais-informacoes">
                        <h1>Mais informações</h1>
                        Esperemos que esteja esclarecido e, como mencionado anteriormente, se houver algo que você não tem certeza se precisa ou não, geralmente é mais seguro deixar os cookies ativados, caso interaja com um dos recursos que você usa em nosso site.
                        Esta política é efetiva a partir de Setembro/2020.

                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
        name: "InfoDesktopComponent",
        data() {
            return {
                show: false
            }
        },
        computed: {
            ...mapGetters([])
        },
        methods: {
            yes() {
                window.removeEventListener('keyup', this.keyUpEventHandler);
                this.$parent.focusGame();
                this.$parent.view_terms = false;
            },
            exit() {
                window.removeEventListener('keyup', this.keyUpEventHandler);
                this.$parent.view_terms = false;
                this.$parent.focusGame();
            },
            keyUpEventHandler(e) {
                if (e.key == "Escape") {
                    this.exit();
                }
            }
        },
        mounted() {
            this.show = true;
            window.addEventListener('keyup', this.keyUpEventHandler);
        }
    }
</script>
<style scoped>
    #bg
    {
        bottom: 0;
        height: 872px;
        left: calc(50% - 960px);
        position: fixed;
        width: 1920px;
    }
    #bg-1
    {
        background-color: rgba(0, 0, 0, .5);
        height: 100%;
        left: 0;
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 1;
    }
    #terms {
        background-color: rgba(0, 0, 0, 0);
        font-family: 'Roboto';
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
        z-index: 8;
    }
    #raio
    {
        height: 575px;
        left: calc(50% - 269px);
        position: fixed;
        top: 0;
        width: 538px;
    }
    #box
    {
        background-color: #fff;
        border-radius: 30px;
        box-shadow: 2px 2px 2px rgba(0, 0, 0, .1);
        box-sizing: border-box;
        color: #777;
        display: block;
        height: auto;
        left: calc(50% - 400px);
        margin: 0 0 30px 0;
        padding: 10px;
        position: absolute;
        text-align: center;
        top: 100px;
        width: 800px;
        z-index: 10;
    }
    h3
    {
        background-color: #9dca26;
        border-bottom: solid 2px rgba(0, 0, 0, .05);
        border-radius: 15px;
        box-shadow: 0 -1px 0 rgba(255, 255, 255, .5);
        box-sizing: border-box;
        color: white;
        margin: -30px auto;
        padding: 15px;
        width: 180px;
    }
    span
    {
        position: absolute;
        right: -30px;
        top: -30px;
    }
    h1
    {
        font-family: inherit;
    }

    /*----- menu -----*/
    #menu
    {
        font-size: 20px;
        margin-top: 45px;
    }
    #menu > ul > li
    {
        box-sizing: border-box;
        display: -block;
        font-size: 16px;
        list-style: none;
        padding: 10px 5px;
        text-align: left;
        vertical-align: middle;
    }
    #menu > ul > li > a
    {
        font-weight: bold;
    }
    #menu > ul > li:nth-child(1)
    {
        width: 40%;
    }
    #menu > ul > li:nth-child(2)
    {
        width: 50%;
    }
    /*----- \menu\ -----*/
    


    #textos
    {
        margin: 25px 0;
        text-align: justify;
    }
    #textos > div
    {
        box-sizing: border-box;
        line-height: 25px;
        padding: 20px;
    }
    #textos > div > h1
    {
        box-sizing: border-box;
        line-height: 35px;
        padding: 10px 0 10px 0;
        text-align: left;
    }




    .btn-01
    {
        background-color: #fff;
        border-radius: 37px;
        box-shadow: 5px 5px 5px rgba(0, 0, 0, .2);
        box-sizing: border-box;
        color: #9dca26 !important;
        display: inline-block;
        font-family: 'Paper Cutout';
        font-size: 60px;
        height: 58px;
        line-height: 34px;
        padding: 12px 15px;
        text-align: center;
        width: 90%;
    }
    .btn-01 > a
    {
        position: absolute;
    }
    .rot
    {
        transform: rotate(180deg);
    }
    .fade-enter-active, .fade-leave-active {
        top: calc(50% - 110px);
        opacity: 1;
        transition: all .5s ease-out;
    }
    .fade-enter, .fade-leave-to {
        top: 50%;
        opacity: 0;
    }

    @media screen and (max-width: 550px)
    {
        #text > ul > li
        {
            display: block;
            text-align: center;
            width: 100% !important;
        }
    }
    @media screen and (max-width: 980px)
    {
        #box
        {
            left: 10%;
            width: 80%;
        }
    }
</style>